import Photospots from './Photospots';

export default Photospots;
